import { useState } from "react";
import { styled } from "@mui/material/styles";
import { CircularProgress } from "@mui/material";
import { useLocalTranslationState } from "../../context/AppContext/AppContext";
import RegisterEmail from "./EnterEmail";
import SetPassword from "./SetPassword";
import Success from "../Signup/Success";

const LoadingContainer = styled("div")({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  zIndex: 1000,
});

enum ResetPasswordState {
  Loading,
  EnterEmail,
  SetPassword,
  Success,
}

function ResetPassword({
  setLoginState,
}) {

  const { _translate } = useLocalTranslationState();

  const [resetPasswordState, setResetPasswordState] = useState<ResetPasswordState>(ResetPasswordState.EnterEmail);
  const [username, setUsername] = useState("");
  const [authError, setAuthError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const onBack = async () => {
    setResetPasswordState(ResetPasswordState.EnterEmail);
  };

  return (
    <>
      {isLoading === true && (
        <LoadingContainer>
          <CircularProgress />
        </LoadingContainer>
      )}
      {resetPasswordState === ResetPasswordState.EnterEmail && (
        <RegisterEmail
          username={username}
          setIsLoading={setIsLoading}
          setUsername={setUsername}
          setResetPasswordState={() => setResetPasswordState(ResetPasswordState.SetPassword)}
          authError={authError}
          setAuthError={setAuthError}
        />
      )}
      {resetPasswordState === ResetPasswordState.SetPassword && (
        <SetPassword
          username={username}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          onBack={onBack}
          setResetPasswordState={() => setResetPasswordState(ResetPasswordState.Success)}
        />
      )}
      {resetPasswordState === ResetPasswordState.Success && (
        <Success
          onSubmit={setLoginState}
          title={_translate("Your password has been reset")}
          subTitle1={_translate("You'll need to log back in using the new password")}
          subTitle2={_translate("Be sure to keep it safe")}
          buttonText={_translate("Go to log in")}
        />
      )}
    </>
  )
}

export default ResetPassword;